import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=780492e2&scoped=true"
import script from "./addressEdit.vue?vue&type=script&lang=js"
export * from "./addressEdit.vue?vue&type=script&lang=js"
import style0 from "./addressEdit.vue?vue&type=style&index=0&id=780492e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780492e2",
  null
  
)

export default component.exports